import { Value } from 'formulascript/interpreter';

import { wrapFunction } from '../utils';

export const REMOVECOLUMN = (table: Value, column: number): Value[] => {
  // Check index bounds.
  if (column < 0) {
    throw new Error('REMOVECOLUMN expects a positive column index');
  }

  const copy = structuredClone(table) as Value[];

  copy.forEach((row, i) => {
    if (!Array.isArray(row)) {
      throw new Error(`REMOVECOLUMN invalid row at index ${i}`);
    }

    row.splice(column, 1);
  });

  return copy;
};

export default wrapFunction(REMOVECOLUMN, {
  name: 'REMOVECOLUMN',
  nargs: 2,
  types: ['array', 'number'],
});
